import React, { useState, useEffect } from "react";
import {
  Modal,
  Button,
  Box,
  IconButton,
  Grid,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Card,
  CardMedia,
  CardContent,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import CloseIcon from "@mui/icons-material/Close";

import Tamilfield from "../../../../../../../components/tamilfield/index";
import { useFormik } from "formik";
import * as Yup from "yup";
import frontpreviewapi from "../../../../../../../services/managelicense/index";
import {
  setEncryptedCookie,
  getDecryptedCookie,
  removeCookie,
} from "../../../../../../../utils";
import {
  showSnackbar,
  hideSnackbar,
} from "../../../../../../../redux/snackbar/actions";
import {
  showLoader,
  hideLoader,
} from "../../../../../../../redux/loader/actions";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
const useStyles = makeStyles({
  animatedButton: {
    background: "linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)",
    color: "#fff",
    padding: "10px 30px",
    fontSize: "16px",
    fontWeight: "bold",
    textTransform: "none",
    borderRadius: "5px",
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "scale(1.05)",
      background: "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
    },
  },
  underline: {
    display: "inline-block",
    borderBottom: "2px solid #000",
    paddingBottom: "0.5px !important",
  },
  "@media print": {
    "@page": {
      size: "A4 landscape",
      margin: "0",
    },
    body: {
      margin: "0",
      padding: "0",
    },
  },
});

const LicensePrintModal = ({
  open,
  onClose,
  color,
  businessuuid,
  tempImg,
  firstCanvasRef,
  license,
  secondCanvasRef,
  billpreviewbusinessuuid,
  setBillPreviewBusinessuuid,
  licenseuuid,
  setLicenseUuid,
  modalClose,
  setLicensePrintModalBack,
  businesssid,
  setLanguageType,
  languageType,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const languageTemp = businesssid?.data[0]?.input_language;
  const language = getDecryptedCookie("lll");
  const proid = getDecryptedCookie("proid")

  const img = getDecryptedCookie("img");
  const textColorStyle = {
    color: color?.color || getDecryptedCookie("col"),
  };
  const { productid, busUid } = useParams();
  const businessid = getDecryptedCookie("bi") || busUid;
  const uuid = getDecryptedCookie("lic");
  const classes = useStyles();
  const [isEditable, setIsEditable] = useState(false);
  const [openCancelModal, setOpenCancelModal] = useState(false);

  const [inputValue, setInputValue] = useState({
    content1:
      language === "en" || language === "enta"
        ? "Below properties are pledged with me of Rs:"
        : "அடியிற்கண்ட சொத்துக்கள் என்னிடம் அடகு வைத்து ரூபாய்",
    content2:
      language === "en" || language === "enta"
        ? "Interest on this will be charged as per Pawnbroker Act."
        : "இதற்கு வட்டி பான்புரோக்கர் சட்டப்படி வசூலிக்கப்படும்",
    content3:
      language === "en" || language === "enta"
        ? "Details of Pledged Properties"
        : "அடகு வைத்த சாமான்களின் விபரம்",
    content4:
      language === "en" || language === "enta"
        ? "and declare that I am not affected by President Act 31-76 & 40/78."
        : "மற்றும் சட்டம் 31-76 & 40/78 ஆல் நான் பாதிக்கப்படவில்லை என்று அறிவிக்கிறேன்.",
    content5:
      language === "en" || language === "enta"
        ? "Interest should be renewed regularly every 3 months."
        : "3 மாதத்திற்கு ஒருமுறை தவறாமல் வட்டி கட்டி புதுப்பித்து கொள்ளவேண்டும்",
    content6:
      language === "en" || language === "enta"
        ? ".I promise to auction the jewel if it is not released within one year and seven days (372)"
        : " ஒரு வருடம் ஏழு நாட்களுக்குள் (372) பொருட்களை மீட்கவில்லை என்றால் ஏலத்தில் விட உறுதியளிக்கிறேன்.",
    content7:
      language === "en" || language === "enta"
        ? ".I agree to repledge them for the goods I have pledged."
        : "நான் தங்களிடம் அடகு வைத்த பொருட்களை மறுஈடு வைக்க சம்மதிக்கிறேன்.",
    content8:
      language === "en" || language === "enta" ? "items" : "பொருட்களின்",
  });

  const licNum = getDecryptedCookie("lic");
  const handleChange = (e) => {
    setInputValue({ ...inputValue, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    setIsEditable(false);
    setLicensePrintModalBack(true);
  };

  const handleNext = () => {
    setLicensePrintModalBack(true);
    setIsEditable(false);
    onClose();
  };

  const [frontPreview, setFrontPreview] = useState();
  const [busTemplateUuid, setBusTemplateUuid] = useState("");
  const handleSubmit = (formData) => {
    dispatch(showLoader());
    const data = {

      string1: formData?.content1 ? formData.content1 : "",
      string2: formData?.content2 ? formData.content2 : "",
      string3: formData?.content3 ? formData.content3 : "",
      string4: formData?.content4 ? formData.content4 : "",
      string5: formData?.content5 ? formData.content5 : "",
      string6: formData?.content6 ? formData.content6 : "",
      string7: formData?.content7 ? formData.content7 : "",
      string8: formData?.content8 ? formData.content8 : "",
    };
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status) {
        dispatch(
          showSnackbar({
            message: res?.data?.data?.message,
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        setLicensePrintModalBack(true);
        setIsEditable(false);
        previewfronteditFormik.resetForm();
        onClose();
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      console.log(err);
      dispatch(
        showSnackbar({
          message: err?.response?.data?.data?.message,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    frontpreviewapi
      .updateFrontPreview(proid, busTemplateUuid, data)
      .then(onSuccess)
      .catch(onFailure);
  };

  const handleEdit = () => {
    // setIsEditable(!isEditable);
    navigate("/subscriptions/editprint")
  };

  const billfronteditPreview = () => {
    const template_name = "loan_print_frontside";
    dispatch(showLoader());
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res.data.status) {
        const data = res.data.data.data[0];
        setFrontPreview(data.customization_field);
        setBusTemplateUuid(data.bus_template_uuid);
      }
    };

    const onFailure = (err) => {
      dispatch(hideLoader());
      console.error("Failed to fetch saved image", err);
    };

    frontpreviewapi
      .getbillfronteditPreview(proid, businessid, uuid, template_name, languageTemp)
      .then(onSuccess)
      .catch(onFailure);
  };

  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        billfronteditPreview();
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [open]);

  const previewfronteditFormik = useFormik({
    initialValues: {
      content1: "",
      content2: "",
      content3: "",
      content4: "",
      content5: "",
      content6: "",
      content7: "",
      content8: "",
    },
    validationSchema: Yup.object({
      content1: Yup.string()
        .max(60, "Content  cannot exceed 60 characters"),
      content2: Yup.string()
        .max(65, "Content  cannot exceed 65 characters"),
      content3: Yup.string()
        .max(50, "Content  cannot exceed 50 characters"),
      content4: Yup.string()
        .max(120, "Content  cannot exceed 120 characters"),
      content5: Yup.string()
        .max(120, "Content  cannot exceed 120 characters"),
      content6: Yup.string()
        .max(120, "Content  cannot exceed 120 characters"),
      content7: Yup.string()
        .max(120, "Content  cannot exceed 120 characters"),
      content8: Yup.string()
        .max(25, "Content  cannot exceed 25 characters"),
    }),
    onSubmit: handleSubmit,
  });

  useEffect(() => {
    previewfronteditFormik.setFieldValue("content1", inputValue?.content1);
    previewfronteditFormik.setFieldValue("content2", inputValue?.content2);
    previewfronteditFormik.setFieldValue("content3", inputValue?.content3);
    previewfronteditFormik.setFieldValue("content4", inputValue?.content4);
    previewfronteditFormik.setFieldValue("content5", inputValue?.content5);
    previewfronteditFormik.setFieldValue("content6", inputValue?.content6);
    previewfronteditFormik.setFieldValue("content7", inputValue?.content7);
    previewfronteditFormik.setFieldValue("content8", inputValue?.content8);
  }, []);

  const handleClose = () => {
    modalClose();
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="bill-preview-modal"
      aria-describedby="bill-preview-description"
    >
      <Box
        className={classes.modalContent}
        sx={{
          bgcolor: "white",
          boxShadow: 24,
          borderRadius: 2,
          p: 4,
          outline: "none",
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            position: "absolute",
            top: 15,
            right: 10,
            zIndex: 100,
          }}
        >
          {isEditable && (
            <>
              <Chip
                label="Next"
                size="small"
                onClick={previewfronteditFormik.handleSubmit}
                variant="contained"
                color="success"
                sx={{
                  color: "white",
                  padding: 1,
                  mr: 1,
                  "&:hover": {
                    backgroundColor: "rgba(255, 0, 0, 0.6)",
                    color: "red.700",
                  },
                  transition: "background-color 0.3s ease",
                }}
              />

            </>
          )}
          {uuid && (
            <>
              <Chip
                label={isEditable ? "Cancel" : "Edit"}
                size="small"
                onClick={handleEdit}
                variant="contained"
                color={isEditable ? "error" : "warning"}
                sx={{
                  color: "white",
                  padding: 1,
                  "&:hover": {
                    backgroundColor: "rgba(255, 0, 0, 0.6)",
                    color: "red.700",
                  },
                  transition: "background-color 0.3s ease",
                }}
              />
              {!isEditable && (
                <Chip
                  label="Next"
                  size="small"
                  onClick={handleNext}
                  variant="contained"
                  color="success"
                  sx={{
                    color: "white",
                    padding: 1,
                    marginLeft: "5px",
                    "&:hover": {
                      backgroundColor: "rgba(255, 0, 0, 0.6)",
                      color: "red.700",
                    },
                    transition: "background-color 0.3s ease",
                  }}
                />
              )}{" "}
            </>
          )}
          <IconButton
            onClick={onClose}
            sx={{
              color: "red.500",
              padding: 1,
              borderRadius: "50%",
              "&:hover": {
                backgroundColor: "rgba(255, 0, 0, 0.6)",
                color: "red.700",
              },
              transition: "background-color 0.3s ease",
            }}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <Box m={1.6}>
          <Box className="print-content">
            <Grid container spacing={1}>
              <Grid
                item
                md={6}
                sx={{ pr: "7px", borderRight: "1px dashed black" }}
              >
                <Grid container spacing={2}>
                  <Grid item md={12} textAlign="center">
                    <Typography
                      fontSize={16}
                      style={textColorStyle}
                      sx={{ marginBottom: "12px" }}
                      textAlign="center"
                    >
                      {language === "en" || language === "enta"
                        ? "Loan Receipt"
                        : "அடகு ரசீது"}
                    </Typography>
                  </Grid>

                  <Grid
                    item
                    md={12}
                    sx={{
                      display: "flex",
                      mb: 1,
                      mx: "auto",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginTop: "-26px",
                    }}
                  >
                    <Typography fontSize={10} style={textColorStyle}>
                      {language === "en" || language === "enta"
                        ? "Date"
                        : "தேதி"}{" "}
                      : <b>03/01/2022</b>
                    </Typography>
                    <Typography
                      fontSize={25}
                      fontWeight={600}
                      textAlign="center"
                      sx={{ flexGrow: 1, ml: 8 }}
                      style={textColorStyle}
                    >
                      {businesssid?.data[0].bus_name}
                    </Typography>
                    <Typography
                      fontSize={14}
                      style={textColorStyle}
                      textAlign="right"
                    >
                      {language === "en" || language === "enta"
                        ? "Pledge No"
                        : "அடகு எண்"}{" "}
                      : <b>TAG-02833</b>
                    </Typography>
                  </Grid>

                  <Grid
                    item
                    md={12}
                    sx={{
                      display: "flex",
                      mb: 1,
                      mx: "auto",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginTop: "-26px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                      }}
                    >
                      {img && (
                        <img
                          src={img}
                          style={{
                            width: "50px",
                            position: "sticky",
                            zIndex: 1,
                            marginBottom: "-40px",
                          }}
                        />
                      )}
                    </div>
                    <Typography
                      fontSize={10}
                      fontWeight={600}
                      textAlign="center"
                      sx={{ flexGrow: 1, mr: 7 }}
                      style={textColorStyle}
                    >
                      {language === "en" || language === "enta"
                        ? "License No"
                        : "உரிமம் எண்"}
                      : <b>{license.number}</b> /2025
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid
                    item
                    md={6}
                    sx={{
                      textAlign: "center",
                      margin: "auto",
                      marginTop: "-11px",
                    }}
                  >
                    <Typography fontSize={10} style={textColorStyle}>
                      {businesssid?.data[0].address}
                    </Typography>
                    <Typography fontSize={10} style={textColorStyle}>
                      Contact: <b>{businesssid?.data[0].mobile_number}</b>
                    </Typography>
                  </Grid>

                  <Grid item md={7} style={{ paddingTop: "10px" }}></Grid>
                  <Grid
                    item
                    md={5}
                    container
                    alignSelf={"right"}
                    style={{ paddingTop: "10px" }}
                  >
                    <Grid item md={2}>
                      <Typography fontSize={10} style={textColorStyle}>
                        <b>
                          {language === "en" || language === "enta"
                            ? "Rs."
                            : "ரூ."}
                        </b>{" "}
                      </Typography>
                    </Grid>
                    <Grid item md={6} textAlign={"center"}>
                      <Typography
                        fontSize={10}
                        sx={{
                          border: `1px solid ${textColorStyle.color}`,
                        }}
                        style={textColorStyle}
                      >
                        <b>23000</b>
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item md={3.5} style={{ paddingTop: "5px" }}>
                    <Typography fontSize={8} style={textColorStyle}>
                      {language === "en" || language === "enta"
                        ? "Borrower name"
                        : "அடகு வைத்தவரின் பெயர்"}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={8.5}
                    style={{
                      paddingTop: "5px",
                      borderBottom: "1px dashed black",
                    }}
                  >
                    <Typography
                      fontSize={10}
                      sx={{ textAlign: "center" }}
                      style={textColorStyle}
                    >
                      <b>
                        {language === "en" || language === "enta"
                          ? "Gopal, S/o-Muniswamy"
                          : "கோபால், S/o-முனுசாமி"}
                      </b>
                    </Typography>
                  </Grid>
                  <Grid item md={1.5} style={{ paddingTop: "5px" }}>
                    <Typography fontSize={8} style={textColorStyle}>
                      {language === "en" || language === "enta"
                        ? "Address"
                        : "விலாசம்"}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={10.5}
                    style={{
                      paddingTop: "5px",
                      borderBottom: "1px dashed black",
                    }}
                  >
                    <Typography
                      fontSize={8}
                      sx={{ textAlign: "center" }}
                      style={textColorStyle}
                    >
                      <b>
                        {language === "en" || language === "enta"
                          ? "18 Sengutuvan Street, Chidambaram, Kadalur"
                          : "18 செங்கடன் தெரு சிதம்பரம், கடலூர்"}
                      </b>
                    </Typography>
                  </Grid>
                  <Grid item md={1} style={{ paddingTop: "8px" }}>
                    <Typography fontSize={8} style={textColorStyle}>
                      {language === "en" || language === "enta"
                        ? "Occupation"
                        : "தொழில்"}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={7}
                    style={{
                      paddingTop: "8px",
                      borderBottom: "1px dashed black",
                    }}
                  >
                    <Typography
                      fontSize={8}
                      sx={{ textAlign: "center" }}
                      style={textColorStyle}
                    >
                      <b>
                        {language === "en" || language === "enta"
                          ? "Farmer"
                          : "விவசாயம்"}
                      </b>
                    </Typography>
                  </Grid>
                  <Grid item md={4} style={{ paddingTop: "3px" }}>
                    <Typography
                      fontSize={12}
                      sx={{
                        border: `1px solid ${textColorStyle.color}`,
                      }}
                      style={textColorStyle}
                    >
                      {language === "en" || language === "enta"
                        ? "Cell"
                        : "கைபேசி"}
                      &nbsp;:&nbsp;<b>984098409840</b>
                    </Typography>
                  </Grid>

                  <Grid
                    item
                    md={inputValue?.content1 === "" ? 0 : 7.4}
                    style={{ paddingTop: "10px" }}
                  >
                    {isEditable ? (
                      <Tamilfield
                        label="Content"
                        name="content1"
                        id="content1"
                        fullWidth
                        value={previewfronteditFormik.values.content1}
                        onChange={previewfronteditFormik.handleChange}
                        onBlur={previewfronteditFormik.handleBlur}
                        error={
                          previewfronteditFormik.touched.content1 &&
                          Boolean(previewfronteditFormik.errors.content1)
                        }
                        helperText={
                          previewfronteditFormik.touched.content1 &&
                          previewfronteditFormik.errors.content1
                        }
                        setFieldValue={previewfronteditFormik.setFieldValue}
                        InputLabelProps={{ shrink: true }}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "25px",
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "12px",
                          },
                          "& .MuiFormLabel-root": {
                            fontSize: "12px",
                          },
                        }}
                      />
                    ) : (
                      <Typography fontSize={8} style={textColorStyle}>
                        {inputValue?.content1}
                      </Typography>
                    )}
                  </Grid>
                  <Grid
                    item
                    md={inputValue?.content1 === "" ? 11 : 4.6}
                    style={{
                      paddingTop: "3px",
                      borderBottom: "1px dashed black",
                    }}
                  >
                    <Typography
                      fontSize={8}
                      style={textColorStyle}
                      sx={{ textAlign: "center" }}
                    >
                      <b>23000</b>
                    </Typography>
                  </Grid>
                  <Grid item md={1.7} style={{ paddingTop: "10px" }}>
                    <Typography fontSize={8} style={textColorStyle}>
                      {language === "en" || language === "enta"
                        ? "Amount in words"
                        : "எழுத்தால்"}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={7.3}
                    style={{
                      paddingTop: "3px",
                      borderBottom: "1px dashed black",
                    }}
                  >
                    <Typography
                      fontSize={8}
                      sx={{ textAlign: "center" }}
                      style={textColorStyle}
                    >
                      <b>
                        {language === "en" || language === "enta"
                          ? "Twenty three thousand rupees"
                          : "இருபது மூன்று ஆயிரம்"}{" "}
                      </b>
                    </Typography>
                  </Grid>
                  <Grid item md={3} style={{ paddingTop: "10px" }}>
                    <Typography fontSize={8} style={textColorStyle}>
                      {language === "en" || language === "enta"
                        ? "only."
                        : "மட்டும் கொடுக்கப்பட்டது."}
                    </Typography>
                  </Grid>
                  <Grid item md={12} style={{ paddingTop: "10px" }}>
                    {isEditable ? (
                      <Tamilfield
                        label="Content"
                        name="content2"
                        id="content2"
                        fullWidth
                        value={previewfronteditFormik.values.content2}
                        onChange={(e) => {
                          previewfronteditFormik.handleChange(e);
                        }}
                        onBlur={previewfronteditFormik.handleBlur}
                        error={
                          previewfronteditFormik.touched.content2 &&
                          Boolean(previewfronteditFormik.errors.content2)
                        }
                        helperText={
                          previewfronteditFormik.touched.content2 &&
                          previewfronteditFormik.errors.content2
                        }
                        setFieldValue={previewfronteditFormik.setFieldValue}
                        InputLabelProps={{ shrink: true }}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "25px",
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "12px",
                          },
                          "& .MuiFormLabel-root": {
                            fontSize: "12px",
                          },
                        }}
                      />
                    ) : (
                      <Typography fontSize={8} style={textColorStyle}>
                        {inputValue?.content2}
                      </Typography>
                    )}
                  </Grid>

                  <Grid item md={12} style={{ paddingTop: "10px" }}>
                    <TableContainer component={Paper}>
                      <Table
                        sx={{
                          border: `1px solid ${textColorStyle.color}`,
                        }}
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell
                              rowSpan={2}
                              sx={{
                                fontSize: "8px",
                                p: 1,

                                border: `1px solid ${textColorStyle.color}`,

                                textAlign: "center",
                              }}
                              style={textColorStyle}
                            >


                              {isEditable ? (
                                <Tamilfield
                                  label="Content"
                                  name="content3"
                                  id="content3"
                                  fullWidth
                                  value={previewfronteditFormik.values.content3}
                                  onChange={(e) => {
                                    previewfronteditFormik.handleChange(e);
                                  }}
                                  onBlur={previewfronteditFormik.handleBlur}
                                  error={
                                    previewfronteditFormik.touched.content3 &&
                                    Boolean(
                                      previewfronteditFormik.errors.content3
                                    )
                                  }
                                  helperText={
                                    previewfronteditFormik.touched.content3 &&
                                    previewfronteditFormik.errors.content3
                                  }
                                  setFieldValue={
                                    previewfronteditFormik.setFieldValue
                                  }
                                  InputLabelProps={{ shrink: true }}
                                  sx={{
                                    "& .MuiInputBase-root": {
                                      height: "25px",
                                    },
                                    "& .MuiInputBase-input": {
                                      fontSize: "12px",
                                    },
                                    "& .MuiFormLabel-root": {
                                      fontSize: "12px",
                                    },
                                  }}
                                />
                              ) : (
                                <span>{inputValue?.content3}</span>
                              )}
                            </TableCell>
                            <TableCell
                              colSpan={2}
                              sx={{
                                fontSize: "8px",
                                p: 1,
                                textAlign: "center",

                                border: `1px solid ${textColorStyle.color}`,
                              }}
                              style={textColorStyle}
                            >
                              {language === "en" || language === "enta"
                                ? "weight"
                                : "எடை"}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell
                              sx={{
                                fontSize: "10px",
                                p: 1,
                                textAlign: "center",

                                border: `1px solid ${textColorStyle.color}`,
                              }}
                              style={textColorStyle}
                            >
                              {language === "en" || language === "enta"
                                ? "Gram"
                                : "கிராம்"}
                            </TableCell>
                            <TableCell
                              sx={{
                                fontSize: "10px",
                                p: 1,
                                textAlign: "center",

                                border: `1px solid ${textColorStyle.color}`,
                              }}
                              style={textColorStyle}
                            >
                              {language === "en" || language === "enta"
                                ? "Mg"
                                : "மி.கி"}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell
                              sx={{
                                fontSize: "8px",
                                p: 1,
                                border: "none",
                              }}
                              style={textColorStyle}
                            >
                              {language === "en" || language === "enta"
                                ? "Ring - 1"
                                : "பொன் மோதிரம் ஒன்று - 1, பொன் தொங்கல் ஜதை - 1, பொன் மோதிரம் ஒன்று -1, பொன் மாட்டல் ஜதை - 1"}
                            </TableCell>
                            <TableCell
                              rowSpan={2}
                              sx={{
                                fontSize: "13px",
                                p: 1,
                                textAlign: "center",

                                border: `1px solid ${textColorStyle.color}`,
                              }}
                              style={textColorStyle}
                            >
                              8
                            </TableCell>
                            <TableCell
                              rowSpan={2}
                              sx={{
                                fontSize: "13px",
                                p: 1,
                                textAlign: "center",

                                border: `1px solid ${textColorStyle.color}`,
                              }}
                              style={textColorStyle}
                            >
                              000
                            </TableCell>
                          </TableRow>
                          <TableRow sx={{ height: "80px" }}>
                            <TableCell
                              rowSpan={2}
                              sx={{
                                border: "none",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "flex-end",
                                height: "100%",
                                px: 1,
                              }}
                            >
                              <Typography fontSize={10} style={textColorStyle}>
                                {language === "en" || language === "enta"
                                  ? "P_value"
                                  : "மதிப்பு"}{" "}
                                :44{" "}
                              </Typography>

                              <Typography fontSize={10} style={textColorStyle}>
                                {language === "en" || language === "enta"
                                  ? "Seal"
                                  : "சீல்"}{" "}
                                :916{" "}
                              </Typography>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                  <Grid item md={12} style={{ paddingTop: "10px" }}>
                    <Typography
                      fontSize={8}
                      style={textColorStyle}
                      sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: 1,
                      }}
                    >
                      {language === "en" || language === "enta"
                        ? "I declare that my monthly income is above Rs"
                        : "எனது மாத வருமானம்"}
                      <Typography
                        fontSize={8}
                        sx={{
                          textAlign: "center",
                          borderBottom: "1px dashed black",
                          minWidth: "40px",
                        }}
                        style={textColorStyle}
                      >
                        <b>23000</b>
                      </Typography>
                      {language === "en" || language === "enta"
                        ? ""
                        : "க்கு மேல் உள்ளதாக உறுதியளிக்கிறேன்"}

                      <Grid container spacing={1}>
                        {isEditable ? (
                          <>
                            <Grid item xs={12}>
                              <Tamilfield
                                label="Content"
                                name="content4"
                                id="content4"
                                fullWidth
                                value={previewfronteditFormik.values.content4}
                                onChange={(e) => {
                                  previewfronteditFormik.handleChange(e);
                                }}
                                onBlur={previewfronteditFormik.handleBlur}
                                error={
                                  previewfronteditFormik.touched.content4 &&
                                  Boolean(
                                    previewfronteditFormik.errors.content4
                                  )
                                }
                                helperText={
                                  previewfronteditFormik.touched.content4 &&
                                  previewfronteditFormik.errors.content4
                                }
                                setFieldValue={
                                  previewfronteditFormik.setFieldValue
                                }
                                InputLabelProps={{ shrink: true }}
                                sx={{
                                  "& .MuiInputBase-root": { height: "25px" },
                                  "& .MuiInputBase-input": { fontSize: "12px" },
                                  "& .MuiFormLabel-root": { fontSize: "12px" },
                                  mb: 1,
                                }}
                              />
                            </Grid>

                            <Grid item xs={12}>
                              <Tamilfield
                                label="Content"
                                name="content5"
                                id="content5"
                                fullWidth
                                value={previewfronteditFormik.values.content5}
                                onChange={(e) => {
                                  previewfronteditFormik.handleChange(e);
                                }}
                                onBlur={previewfronteditFormik.handleBlur}
                                error={
                                  previewfronteditFormik.touched.content5 &&
                                  Boolean(
                                    previewfronteditFormik.errors.content5
                                  )
                                }
                                helperText={
                                  previewfronteditFormik.touched.content5 &&
                                  previewfronteditFormik.errors.content5
                                }
                                setFieldValue={
                                  previewfronteditFormik.setFieldValue
                                }
                                InputLabelProps={{ shrink: true }}
                                sx={{
                                  "& .MuiInputBase-root": { height: "25px" },
                                  "& .MuiInputBase-input": { fontSize: "12px" },
                                  "& .MuiFormLabel-root": { fontSize: "12px" },
                                  mb: 1,
                                }}
                              />
                            </Grid>

                            <Grid item xs={12}>
                              <Tamilfield
                                label="Content"
                                name="content6"
                                id="content6"
                                fullWidth
                                value={previewfronteditFormik.values.content6}
                                onChange={(e) => {
                                  previewfronteditFormik.handleChange(e);
                                }}
                                onBlur={previewfronteditFormik.handleBlur}
                                error={
                                  previewfronteditFormik.touched.content6 &&
                                  Boolean(
                                    previewfronteditFormik.errors.content6
                                  )
                                }
                                helperText={
                                  previewfronteditFormik.touched.content6 &&
                                  previewfronteditFormik.errors.content6
                                }
                                setFieldValue={
                                  previewfronteditFormik.setFieldValue
                                }
                                InputLabelProps={{ shrink: true }}
                                sx={{
                                  "& .MuiInputBase-root": { height: "25px" },
                                  "& .MuiInputBase-input": { fontSize: "12px" },
                                  "& .MuiFormLabel-root": { fontSize: "12px" },
                                  mb: 1,
                                }}
                              />
                            </Grid>

                            <Grid item xs={12}>
                              <Tamilfield
                                label="Content"
                                name="content7"
                                id="content7"
                                fullWidth
                                value={previewfronteditFormik.values.content7}
                                onChange={(e) => {
                                  previewfronteditFormik.handleChange(e);
                                }}
                                onBlur={previewfronteditFormik.handleBlur}
                                error={
                                  previewfronteditFormik.touched.content7 &&
                                  Boolean(
                                    previewfronteditFormik.errors.content7
                                  )
                                }
                                helperText={
                                  previewfronteditFormik.touched.content7 &&
                                  previewfronteditFormik.errors.content7
                                }
                                setFieldValue={
                                  previewfronteditFormik.setFieldValue
                                }
                                InputLabelProps={{ shrink: true }}
                                sx={{
                                  "& .MuiInputBase-root": { height: "25px" },
                                  "& .MuiInputBase-input": { fontSize: "12px" },
                                  "& .MuiFormLabel-root": { fontSize: "12px" },
                                  mb: 1,
                                }}
                              />
                            </Grid>
                          </>
                        ) : (
                          <Grid item xs={12}>
                            {inputValue?.content4} &nbsp;
                            {inputValue?.content5} &nbsp;
                            {inputValue?.content6} &nbsp;
                            {inputValue?.content7}
                          </Grid>
                        )}
                      </Grid>
                    </Typography>
                  </Grid>

                  <Grid item md={12} style={{ paddingTop: "3px" }}>
                    {isEditable ? (
                      <Tamilfield
                        label="Content"
                        name="content8"
                        id="content8"
                        fullWidth
                        value={previewfronteditFormik.values.content8}
                        onChange={(e) => {
                          previewfronteditFormik.handleChange(e);
                        }}
                        onBlur={previewfronteditFormik.handleBlur}
                        error={
                          previewfronteditFormik.touched.content8 &&
                          Boolean(previewfronteditFormik.errors.content8)
                        }
                        helperText={
                          previewfronteditFormik.touched.content8 &&
                          previewfronteditFormik.errors.content8
                        }
                        setFieldValue={previewfronteditFormik.setFieldValue}
                        InputLabelProps={{ shrink: true }}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "25px",
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "12px",
                          },
                          "& .MuiFormLabel-root": {
                            fontSize: "12px",
                          },
                        }}
                      />
                    ) : (
                      <Typography fontSize={7} style={textColorStyle}>
                        {language === "en" || language === "enta"
                          ? `No. of ${inputValue?.content8}`
                          : `${inputValue?.content8} எண்ணிக்கை `}
                        :<b style={{ fontSize: "10px" }}>4</b>
                      </Typography>
                    )}
                  </Grid>

                  <Grid item md={6} style={{ paddingTop: "20px" }}>
                    <Typography fontSize={7} style={textColorStyle}>
                      {language === "en" || language === "enta"
                        ? "Signature of Lender /Agent"
                        : "கடன் கொடுத்தவர் (அ) ஏஜெண்டின் கையெழுத்து"}
                    </Typography>
                  </Grid>

                  <Grid item md={6} style={{ paddingTop: "20px" }}>
                    <Typography fontSize={7} style={textColorStyle}>
                      {language === "en" || language === "enta"
                        ? "Signature of Pawner (or) Left thumb impression"
                        : "அடகு வைத்தவரின் கையெழுத்து (அ) இடது கை பெருவிரலின் ரேகை"}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item md={6} sx={{ pr: "7px" }}>
                <Grid container spacing={2}>
                  <Grid item md={12} textAlign="center">
                    <Typography
                      fontSize={16}
                      style={textColorStyle}
                      sx={{ marginBottom: "12px" }}
                      textAlign="center"
                    >
                      {language === "en" || language === "enta"
                        ? "Loan Receipt"
                        : "அடகு ரசீது"}
                    </Typography>
                  </Grid>

                  <Grid
                    item
                    md={12}
                    sx={{
                      display: "flex",
                      mb: 1,
                      mx: "auto",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginTop: "-26px",
                    }}
                  >
                    <Typography fontSize={10} style={textColorStyle}>
                      {language === "en" || language === "enta"
                        ? "Date"
                        : "தேதி"}{" "}
                      : <b>03/01/2022</b>
                    </Typography>
                    <Typography
                      fontSize={25}
                      fontWeight={600}
                      textAlign="center"
                      sx={{ flexGrow: 1, ml: 8 }}
                      style={textColorStyle}
                    >
                      {businesssid?.data[0].bus_name}
                    </Typography>
                    <Typography
                      fontSize={14}
                      style={textColorStyle}
                      textAlign="right"
                    >
                      {language === "en" || language === "enta"
                        ? "Pledge No"
                        : "அடகு எண்"}{" "}
                      : <b>TAG-02833</b>
                    </Typography>
                  </Grid>

                  <Grid
                    item
                    md={12}
                    sx={{
                      display: "flex",
                      mb: 1,
                      mx: "auto",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginTop: "-26px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                      }}
                    >

                      {img && (
                        <img
                          src={img}
                          style={{
                            width: "50px",
                            position: "sticky",
                            zIndex: 1,
                            marginBottom: "-40px",
                          }}
                        />
                      )}
                    </div>
                    <Typography
                      fontSize={10}
                      fontWeight={600}
                      textAlign="center"
                      sx={{ flexGrow: 1, mr: 7 }}
                      style={textColorStyle}
                    >
                      {language === "en" || language === "enta"
                        ? "License No"
                        : "உரிமம் எண்"}
                      : <b>{license.number}</b> /2025
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid
                    item
                    md={6}
                    sx={{
                      textAlign: "center",
                      margin: "auto",
                      marginTop: "-11px",
                    }}
                  >
                    <Typography fontSize={10} style={textColorStyle}>
                      {businesssid?.data[0].address}
                    </Typography>
                    <Typography fontSize={10} style={textColorStyle}>
                      Contact: <b>{businesssid?.data[0].mobile_number}</b>
                    </Typography>
                  </Grid>

                  <Grid item md={7} style={{ paddingTop: "10px" }}></Grid>
                  <Grid
                    item
                    md={5}
                    container
                    alignSelf={"right"}
                    style={{ paddingTop: "10px" }}
                  >
                    <Grid item md={2}>
                      <Typography fontSize={10} style={textColorStyle}>
                        <b>
                          {language === "en" || language === "enta"
                            ? "Rs."
                            : "ரூ."}
                        </b>{" "}
                      </Typography>
                    </Grid>
                    <Grid item md={6} textAlign={"center"}>
                      <Typography
                        fontSize={10}
                        sx={{
                          border: `1px solid ${textColorStyle.color}`,
                        }}
                        style={textColorStyle}
                      >
                        <b>23000</b>
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item md={3.5} style={{ paddingTop: "5px" }}>
                    <Typography fontSize={8} style={textColorStyle}>
                      {language === "en" || language === "enta"
                        ? "Borrower name"
                        : "அடகு வைத்தவரின் பெயர்"}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={8.5}
                    style={{
                      paddingTop: "5px",
                      borderBottom: "1px dashed black",
                    }}
                  >
                    <Typography
                      fontSize={10}
                      sx={{ textAlign: "center" }}
                      style={textColorStyle}
                    >
                      <b>
                        {" "}
                        {language === "en" || language === "enta"
                          ? "Gopal, S/o-Muniswamy"
                          : "கோபால், S/o-முனுசாமி"}
                      </b>
                    </Typography>
                  </Grid>
                  <Grid item md={1.5} style={{ paddingTop: "5px" }}>
                    <Typography fontSize={8} style={textColorStyle}>
                      {language === "en" || language === "enta"
                        ? "Address"
                        : "விலாசம்"}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={10.5}
                    style={{
                      paddingTop: "5px",
                      borderBottom: "1px dashed black",
                    }}
                  >
                    <Typography
                      fontSize={8}
                      sx={{ textAlign: "center" }}
                      style={textColorStyle}
                    >
                      <b>
                        {language === "en" || language === "enta"
                          ? "18 Sengutuvan Street, Chidambaram, Kadalur"
                          : "18 செங்கடன் தெரு சிதம்பரம், கடலூர்"}
                      </b>
                    </Typography>
                  </Grid>
                  <Grid item md={1} style={{ paddingTop: "8px" }}>
                    <Typography fontSize={8} style={textColorStyle}>
                      {language === "en" || language === "enta"
                        ? "Occupation"
                        : "தொழில்"}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={7}
                    style={{
                      paddingTop: "8px",
                      borderBottom: "1px dashed black",
                    }}
                  >
                    <Typography
                      fontSize={8}
                      sx={{ textAlign: "center" }}
                      style={textColorStyle}
                    >
                      <b>
                        {language === "en" || language === "enta"
                          ? "Farmer"
                          : "விவசாயம்"}
                      </b>
                    </Typography>
                  </Grid>
                  <Grid item md={4} style={{ paddingTop: "3px" }}>
                    <Typography
                      fontSize={12}
                      sx={{
                        border: `1px solid ${textColorStyle.color}`,
                        padding: "4px",
                      }}
                      style={textColorStyle}
                    >
                      {language === "en" || language === "enta"
                        ? "Cell"
                        : "கைபேசி"}{" "}
                      &nbsp;:&nbsp;<b>984098409840</b>
                    </Typography>
                  </Grid>
                  <Grid item md={7.4} style={{ paddingTop: "10px" }}>
                    <Typography fontSize={8} style={textColorStyle}>
                      {inputValue?.content1}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={4.6}
                    style={{
                      paddingTop: "3px",
                      borderBottom: "1px dashed black",
                    }}
                  >
                    <Typography
                      fontSize={8}
                      style={textColorStyle}
                      sx={{ textAlign: "center" }}
                    >
                      <b>23000</b>
                    </Typography>
                  </Grid>
                  <Grid item md={1.7} style={{ paddingTop: "10px" }}>
                    <Typography fontSize={8} style={textColorStyle}>
                      {language === "en" || language === "enta"
                        ? "Amount in words"
                        : "எழுத்தால்"}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={7.3}
                    style={{
                      paddingTop: "3px",
                      borderBottom: "1px dashed black",
                    }}
                  >
                    <Typography
                      fontSize={8}
                      sx={{ textAlign: "center" }}
                      style={textColorStyle}
                    >
                      <b>
                        {language === "en" || language === "enta"
                          ? "Twenty three thousand rupees"
                          : "இருபது மூன்று ஆயிரம்"}{" "}
                      </b>
                    </Typography>
                  </Grid>
                  <Grid item md={3} style={{ paddingTop: "10px" }}>
                    <Typography fontSize={8} style={textColorStyle}>
                      {language === "en" || language === "enta"
                        ? "only."
                        : "மட்டும் கொடுக்கப்பட்டது."}
                    </Typography>
                  </Grid>
                  <Grid item md={12} style={{ paddingTop: "10px" }}>
                    <Typography fontSize={8} style={textColorStyle}>
                      {inputValue.content2}
                    </Typography>
                  </Grid>
                  <Grid item md={12} style={{ paddingTop: "10px" }}>
                    <TableContainer component={Paper}>
                      <Table
                        sx={{ border: `1px solid ${textColorStyle.color}` }}
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell
                              rowSpan={2}
                              sx={{
                                fontSize: "8px",
                                p: 1,
                                border: `1px solid ${textColorStyle.color}`,
                                textAlign: "center",
                              }}
                              style={textColorStyle}
                            >
                              {inputValue?.content3}
                            </TableCell>
                            <TableCell
                              colSpan={2}
                              sx={{
                                fontSize: "8px",
                                p: 1,
                                textAlign: "center",
                                border: `1px solid ${textColorStyle.color}`,
                              }}
                              style={textColorStyle}
                            >
                              {language === "en" || language === "enta"
                                ? "weight"
                                : "எடை"}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell
                              sx={{
                                fontSize: "10px",
                                p: 1,
                                textAlign: "center",
                                border: `1px solid ${textColorStyle.color}`,
                              }}
                              style={textColorStyle}
                            >
                              கிராம்
                            </TableCell>
                            <TableCell
                              sx={{
                                fontSize: "10px",
                                p: 1,
                                textAlign: "center",
                                border: `1px solid ${textColorStyle.color}`,
                              }}
                              style={textColorStyle}
                            >
                              {language === "en" || language === "enta"
                                ? "Mg"
                                : "மி.கி"}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell
                              sx={{
                                fontSize: "8px",
                                p: 1,
                                border: "none",
                              }}
                              style={textColorStyle}
                            >
                              {language === "en" || language === "enta"
                                ? "Ring - 1"
                                : "பொன் மோதிரம் ஒன்று - 1, பொன் தொங்கல் ஜதை - 1, பொன் மோதிரம் ஒன்று -1, பொன் மாட்டல் ஜதை - 1"}
                            </TableCell>
                            <TableCell
                              rowSpan={2}
                              sx={{
                                fontSize: "13px",
                                p: 1,
                                textAlign: "center",
                                border: `1px solid ${textColorStyle.color}`,
                              }}
                              style={textColorStyle}
                            >
                              8
                            </TableCell>
                            <TableCell
                              rowSpan={2}
                              sx={{
                                fontSize: "13px",
                                p: 1,
                                textAlign: "center",
                                border: `1px solid ${textColorStyle.color}`,
                              }}
                              style={textColorStyle}
                            >
                              000
                            </TableCell>
                          </TableRow>
                          <TableRow sx={{ height: "80px" }}>
                            <TableCell
                              rowSpan={2}
                              sx={{
                                border: "none",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "flex-end",
                                height: "100%",
                                px: 1,
                              }}
                            >
                              <Typography fontSize={10} style={textColorStyle}>
                                {language === "en" || language === "enta"
                                  ? "P_value"
                                  : "மதிப்பு"}{" "}
                                :44{" "}
                              </Typography>
                              <Typography fontSize={10} style={textColorStyle}>
                                {language === "en" || language === "enta"
                                  ? "Seal"
                                  : "சீல்"}{" "}
                                :916{" "}
                              </Typography>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                  <Grid item md={12} style={{ paddingTop: "10px" }}>
                    <Typography
                      fontSize={8}
                      style={textColorStyle}
                      sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: 1,
                      }}
                    >
                      {language === "en" || language === "enta"
                        ? "I declare that my monthly income is above Rs"
                        : "எனது மாத வருமானம்"}
                      <Typography
                        fontSize={8}
                        sx={{
                          textAlign: "center",
                          borderBottom: "1px dashed black",
                          minWidth: "40px",
                        }}
                        style={textColorStyle}
                      >
                        <b>23000</b>
                      </Typography>
                      {language === "en" || language === "enta"
                        ? ""
                        : "க்கு மேல் உள்ளதாக உறுதியளிக்கிறேன்"}
                      {inputValue?.content4}&nbsp;
                      {inputValue?.content5}&nbsp;
                      {inputValue?.content6}&nbsp;
                      {inputValue?.content7}
                    </Typography>
                  </Grid>

                  <Grid item md={12} style={{ paddingTop: "3px" }}>
                    <Typography fontSize={7} style={textColorStyle}>
                      {language === "en" || language === "enta"
                        ? `No. of 
                              ${inputValue?.content8}`
                        : ` ${inputValue?.content8} எண்ணிக்கை `}
                      <b style={{ fontSize: "10px" }}>4</b>
                    </Typography>
                  </Grid>
                  <Grid item md={6} style={{ paddingTop: "20px" }}>
                    <Typography fontSize={7} style={textColorStyle}>
                      {language === "en" || language === "enta"
                        ? "Signature of Lender /Agent"
                        : "கடன் கொடுத்தவர் (அ) ஏஜெண்டின் கையெழுத்து"}
                    </Typography>
                  </Grid>
                  <Grid item md={6} style={{ paddingTop: "20px" }}>
                    <Typography fontSize={7} style={textColorStyle}>
                      {language === "en" || language === "enta"
                        ? "Signature of Pawner (or) Left thumb impression"
                        : "அடகு வைத்தவரின் கையெழுத்து (அ) இடது கை பெருவிரலின் ரேகை"}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default LicensePrintModal;
